<template>
  <Page class="question" :class="classList">

    <container class="question__container">
      <Header class="question__header" ref="header" :class="{ 'hidden': hideTop }" size="sm"></Header>
      <div class="question__content" ref="content">
        <div class="question__card">
          <div class="question__inner" ref="inner">
            <div class="question__text lead" v-html="question.text"></div>
            <options class="question__options"></options>
          </div>
        </div>
      </div>
    </container>

    <div class="question__navigation" :class="{ 'answered': answered, 'overflow': overflow }">
      <Navigation class="question__navigation-inner"></Navigation>
    </div>


  </Page>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Navigation from '@/components/Quiz/Navigation.vue'
  import Options from '@/components/Quiz/Options.vue'
  import debounce from 'lodash.debounce'
  import { viewNames } from '@/ulils/responsive.breakpoints'

  export default {
    components: {
      Header,
      Navigation,
      Options,
    },
    data () {
      return { observer: null, overflow: false, hideTop: false }
    },
    computed: {
      answered () {
        return this.$store.getters.answered
      },
      busy () {
        return this.$store.state.busy
      },
      question () {
        return this.$store.getters.question
      },
      side () {
        const side = this.$store.state.sides[this.$store.state.current]
        return side || 'left'
      },
      classList () {
        return {
          [`question--${this.side}`]: true,
          'question--answered': this.answered
        }
      },
      view () {
        return this.$store.getters.view
      }
    },
    mounted () {
      setTimeout(() => this.calcOverflow(), 1000)
      this.scrolled = this.scrolled.bind(this)
      this.resized = debounce(this.resized.bind(this), 200)
      this.$el.addEventListener('scroll', this.scrolled)
      window.addEventListener('resize', this.resized)
    },
    beforeDestroy () {
      this.$el.removeEventListener('scroll', this.scrolled)
      window.removeEventListener('resize', this.resized)
    },
    methods: {
      calcOverflow () {
        if (this.$refs.inner && this.view === viewNames.COMPACT) {
          const inner = this.$refs.inner.getBoundingClientRect()
          const innerBottom = inner.y + inner.height
          const gap = this.answered ? 95 : 40
          const over = innerBottom > (this.responsive.vh - gap)
          this.overflow = over
        }

        if (this.$refs.header && this.view === viewNames.FULL) {
          const header = this.$refs.header.$el.getBoundingClientRect()
          this.hideTop = header.y < 20
        }
      },
      resized () {
        this.calcOverflow()
      },
      scrolled () {
        this.calcOverflow()
      },
      next () {
        this.$store.dispatch('next')
      }
    }
  }
</script>

<style lang="scss">
  .question {
  }

  .question__container {
    @include less(tablet) {
      width: auto;
      max-width: 100%;
      padding: 0;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
    }
  }

  .question__header {
    transition: 0.8s opacity, 0.8s transform;

    &.hidden {
      opacity: 0;
      transition-duration: 0.35s;
    }

    @include more(scale) {
      flex: 0 0 auto;
      margin-top: 30px;
    }
    @include less(tablet) {
      margin-top: 15px;
      display: none;
    }
  }

  .question__header .header__special-label {
    transition: 0.7s opacity, 0.7s transform;
  }

  .question__text {
    transition: 1s opacity, 1s transform;
  }

  .question__content {
    transition: 0.3s opacity, 0.3s transform;

    @include more(scale) {
      width: 480px;
      display: flex;
      align-items: center;
      padding: 80px 0;

      .question--right & {
        margin-left: auto;
        margin-right: 0;
      }
      .question--left & {
        margin-right: auto;
        margin-left: 0;
      }
    }
    @include screen-height(high) {
      height: 600px;
    }
    @include less(tablet) {
      margin-top: auto;
      margin-bottom: 0;
      padding-top: 155px;
    }
  }

  .question__card {
    @include less(tablet) {
      background: $background;
      padding: $padding-mobile $padding-mobile 95px;
    }
  }


  .question__inner {
    @include less(tablet) {
      max-width: $container-mobile;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .question__controls {
    @include more(scale) {
      position: fixed;
      left: 50%;

      width: calc(#{$container-desktop}/2);
      .question--right & {
        transform: translateX(-100%)
      }
      .question--left & {
        transform: translateX(0)
      }
    }
    @include screen-height(low) {
      top: 500px;
    }
    @include screen-height(high) {
      top: 664px
    }
  }

  .question__navigation {
    transition: 0.5s opacity, 0.5s transform;

    @include more(scale) {
      position: fixed;
      justify-content: center;
      top: calc(50% + 200px);
      display: flex;
    }

    @include mq(scale) {
      width: 220px;
      margin-left: -110px;
      .question--right & {
        left: 25%;
      }
      .question--left & {
        left: 75%;
      }
    }

    @include mq(desktop) {
      width: 480px;
      .question--right & {
        left: 50%;
        margin-left: -$container-desktop/2;
      }
      .question--left & {
        right: 50%;
        margin-right: -$container-desktop/2;
      }

    }

    @media screen and (min-width: nth(map-get($breakpoints, scale), 1)) and (max-height: 680px) {
      bottom: 20px;
      top: auto;
    }

    @include less(tablet) {
      position: fixed;
      bottom: -60px;
      left: 0;
      width: 100%;
      z-index: 99;
      background: $color-navy;
      padding: 15px 0;
      /*transform: translateY(58px);*/
      /*transition: 0.5s transform;*/
      transition: 0.5s bottom;

      &.answered {
        bottom: 0 !important;
        /*transform: translateY(0)*/
      }
    }

    @include less(tablet) {
      &:after {
        opacity: 0;
        transition: 0.7s opacity;
        content: '';
        display: block;
        position: absolute;
        bottom: 100%;
        margin-bottom: -1px;
        left: 0;
        width: 100%;
        height: 150px;
        pointer-events: none;
        background: linear-gradient(180deg, rgba($color-navy, 0) 0%, $color-navy 89.06%);
      }

      &.overflow {
        &:after {
          opacity: 1;
          transition-duration: 0.5s;
          .quiz-leave-active & {
            opacity: 0;
          }
        }
      }
    }
  }

  .question__navigation-inner {
    transition: 0.5s opacity, 0.5s transform;
    @include more(scale) {
      //width: 480px;
    }
  }

  @include more(scale) {
    .quiz-enter-active {
      .question__header {
        opacity: 0;
        transform: translateY(-100%);
      }
      .question__header .header__special-label {
        opacity: 0;
        transform: translateY(20px)
      }
      .question__text {
        opacity: 0;
        transform: translateX(30px);
      }
      .question__content {
        opacity: 0;
      }
      .question__navigation-inner {
        opacity: 0;
        transform: scale(0.85, 0.85);
      }
    }
    .quiz-enter-to {
      .question__header {
        opacity: 1;
        transform: translateY(0);
      }
      .question__header .header__special-label {
        opacity: 1;
        transform: translateY(0);
        transition-delay: 0.3s;
      }
      .question__text {
        opacity: 1;
        transform: translateX(0);
      }
      .question__content {
        opacity: 1;
      }
      .question__navigation-inner {
        opacity: 1;
        transform: scale(1, 1);
      }
    }
    .quiz-leave {
      .question__content {
        opacity: 1;
        transform: translateX(0)
      }
    }
    .quiz-leave-active {
      .question__header {
        opacity: 0;
        transform: translateY(-100%);
        transition-delay: 0.3s;
      }
      .question__header .header__special-label {
        opacity: 0;
        transform: translateY(-20px);
      }
      .question--right .question__content {
        opacity: 0;
        transform: translateX(50px);
      }
      .question--left .question__content {
        opacity: 0;
        transform: translateX(-50px);
      }
      .question__navigation-inner {
        opacity: 0;
        transform: scale(0.85, 0.85);
      }
    }
  }


  @include less(tablet) {
    .quiz-enter-active {
      .question__header {
        opacity: 0;
        transform: translateY(-100%)
      }
      .question__card {
        transform: translateY(100%)
      }
      .question__navigation {
        bottom: -105px
      }
    }
    .quiz-enter-to {
      .question__header {
        opacity: 1;
        transform: translateY(0)
      }
      .question__card {
        transform: translateY(0);
        transition-duration: 1s;
      }
      .question__navigation {
        bottom: -60px
      }
    }
    .quiz-leave-active {
      .question__header {
        opacity: 0;
        transform: translateY(-100%)
      }
      .question__card {
        transform: translateY(100%);
        transition-duration: 1s;
      }
      .question__navigation {
        bottom: -105px !important;
      }
    }
  }
</style>
